import script from "./amount-with-unit-input.vue?vue&type=script&setup=true&lang=js"
export * from "./amount-with-unit-input.vue?vue&type=script&setup=true&lang=js"

import "./amount-with-unit-input.vue?vue&type=style&index=0&id=3c3ee191&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3ee191"]])

export default __exports__